import { useState, useEffect, useRef } from 'react'
import Pusher from 'pusher-js/types/src/core/pusher'
import getPusherClient from '~services/pusher'

export type BidStateType = {
  bid: number
  nextBid: number
  bidder: number
}

const usePusher = (
  slug: string
): {
  dataIsOutOfDateState: boolean
  setDataIsOutOfDateState: (boolean) => void
  pusherData: BidStateType
} => {
  const pusherRef = useRef<Pusher>(null)
  const [dataIsOutOfDateState, setDataIsOutOfDateState] = useState(false)
  const [pusherData, setPusherData] = useState<BidStateType>({
    bid: 0,
    nextBid: 0,
    bidder: 0,
  })

  useEffect(() => {
    if (!pusherRef.current && slug) {
      pusherRef.current = getPusherClient()
      const pusherChannelName = slug.replace(/-/g, '')
      const channel = pusherRef.current.subscribe(pusherChannelName)
      channel.bind('bid_event', (data) => {
        setPusherData({
          bid: data.currentPriceRaw,
          nextBid: data.currentBidRaw,
          bidder: data.bidder,
        })
        setDataIsOutOfDateState(true)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    dataIsOutOfDateState,
    setDataIsOutOfDateState,
    pusherData,
  }
}

export default usePusher
